module.exports = __webpack_public_path__ + "img/内蒙古.ea1fc441.png";